import {AttributeLink} from '@acng/frontend-stargazer';

import {getLocalAmateur} from '../../amateurPool/context/amateur.js';
import {onClick} from '../../layout/service/worker.js';
import {togglePin} from '../service/http.js';

/**
 * @group DOM Attribute
 */
const name = 'onclick-pin';

AttributeLink(
  name,
  () => (element) => onClick(element, (element) => togglePin(element, getLocalAmateur(element))),
);

export {name as ONCLICK_PIN};
